// extracted by mini-css-extract-plugin
export default {"container":"promotion-notification_container__3FRNd","card":"promotion-notification_card__1p5Qb"};